import { all, fork } from 'redux-saga/effects'
import getSaga from './getSaga'

export default function* organizationSettingsSaga() {
  yield all([fork(getSaga)])
}
